// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  scroll-behavior: smooth;
}

.container {
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #232223;
  transition: all 2s ease-in-out;
  -webkit-font-smoothing: antialiased;
}
.container__about {
  background-image: linear-gradient(to left top, #29335c, #29335c, #29335c, #29335c, #29335c, #473d64, #60496b, #765671, #9e7882, #bba09b, #d5c9c1, #f3f2ef);
  position: relative;
  color: #f3f2ef;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 2;
  text-align: center;
  z-index: 1;
}
.container__about_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0em 2em;
  width: 30%;
  border-radius: 4px;
  z-index: 2;
  font-family: "Alpino-Black";
  color: #ff7db1;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border-radius: 4px;
  left: 0;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 2em;
}
.container__about_title > span {
  color: #0abab5;
}
.container__about_section {
  display: flex;
  flex-direction: row;
}
.container__about_p {
  width: 70%;
  z-index: 2;
  padding: 1.5em;
  line-height: 2em;
  font-size: 1.5em;
  font-family: "Alpino-Black";
  font-weight: bold;
  background-color: #f3f2ef;
  color: #c99578;
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border-radius: 10px;
}
.container__about_p_i {
  color: #0abab5;
  font-weight: bold;
  font-family: "Alpino-Black";
  padding: 1em;
  font-size: 1.2em;
}
.container__about_img-container > img {
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.5);
  object-fit: cover;
}
.container__feature {
  display: flex;
  flex-direction: column;
  background-image: url("https://awt-site.s3.us-east-2.amazonaws.com/white-couch.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 80vh;
  position: relative;
  z-index: 2;
}
.container__feature_overlay {
  position: absolute;
  width: 100%;
  height: 80vh;
  z-index: 1;
  opacity: 0;
  background-color: #eddcd2;
}
.container__feature_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0em 2em;
  width: 30%;
  border-radius: 4px;
  z-index: 2;
  font-family: "Alpino-Black";
  color: #ff7db1;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);
  border-radius: 4px;
  left: 0;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 2em;
}
.container__feature_content {
  z-index: 2;
  display: flex;
  flex-direction: row;
  gap: 8em;
  justify-content: center;
  padding: 2em;
}
.container__feature_content_img {
  width: 28em;
  height: 30em;
  border-radius: 8px;
  overflow: hidden;
  transition: all 1s ease-in-out;
  border: 2px solid #ffbcd7;
}
.container__feature_content_img:hover {
  cursor: pointer;
}
.container__gallery {
  background-image: url("https://awt-site.s3.us-east-2.amazonaws.com/white-couch.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
}
.container__gallery_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0em 2em;
  width: 30%;
  border-radius: 4px;
  z-index: 2;
  font-family: "Alpino-Black";
  color: #390879;
  background-color: white;
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border-radius: 4px;
  left: 0;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 2em;
}
.container__gallery_top-grid {
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2em;
  padding: 4em;
  z-index: 2;
}
.container__gallery_top-grid_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.container__gallery_top-grid_container > img {
  height: 40em;
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  background-color: white;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.container__gallery_top-grid_container > img:hover {
  z-index: 1;
  transform: translateY(-1px);
  height: 50em;
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}
.container__gallery_top-grid_buy-btn {
  padding: 1em;
  width: 5em;
  text-align: center;
  background-color: #0abab5;
  color: black;
  position: absolute;
  bottom: 0;
  right: 0;
}
.container__gallery_middle-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-self: center;
  gap: 3em;
  padding: 3em;
  z-index: 2;
}
.container__gallery_middle-grid_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.container__gallery_middle-grid_container > img {
  height: 40em;
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  background-color: white;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.container__gallery_middle-grid_container > img:hover {
  height: 50em;
  z-index: 1;
  transform: translateY(-1px);
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}
.container__gallery_middle-grid_buy-btn {
  padding: 1em;
  width: 5em;
  text-align: center;
  background-color: #0abab5;
  color: black;
  position: absolute;
  bottom: 0;
  right: 0;
}
.container__gallery_bottom-grid {
  display: flex;
  flex-direction: row;
  align-self: center;
  gap: 3em;
  padding: 3em;
}
.container__gallery_bottom-grid_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.container__gallery_bottom-grid_container > img {
  height: 40em;
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  background-color: white;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.container__gallery_bottom-grid_container > img:hover {
  height: 50em;
  z-index: 1;
  transform: translateY(-1px);
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}
.container__gallery_bottom-grid_buy-btn {
  padding: 1em;
  width: 5em;
  text-align: center;
  background-color: #0abab5;
  color: black;
  position: absolute;
  bottom: 0;
  right: 0;
}
.container__events {
  display: flex;
  flex-direction: column;
  gap: 1em;
  position: relative;
}
.container__events_section {
  display: flex;
  flex-direction: row;
  gap: 1em;
  justify-content: center;
  align-items: center;
}
.container__events_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0em 2em;
  width: 30%;
  border-radius: 4px;
  z-index: 2;
  font-family: "Alpino-Black";
  color: #ff7db1;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border-radius: 4px;
  left: 0;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 2em;
}
.container__events_img-container {
  width: 5em;
  height: 30em;
  border-radius: 2.5em;
  border: 1px solid #9ae0d9;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;
}
.container__events_img-container:active {
  width: 45em;
}
.container__book {
  display: flex;
  flex-direction: column;
  position: relative;
}
.container__book_container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 1em;
  padding: 10em;
  z-index: 2;
}
.container__book_container_lf {
  width: 100%;
  height: 50vh;
  background-color: white;
}
.container__book_container_rh {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.container__book_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0em 2em;
  width: 30%;
  border-radius: 4px;
  z-index: 2;
  font-family: "Alpino-Black";
  color: #eddcd2;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  border-radius: 4px;
  left: 0;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 2em;
}
.container__footer {
  border: 1px solid rgba(237, 220, 210, 0.5);
  background-color: #232223;
  border-radius: 4px;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3em;
}
.container__footer_links {
  display: flex;
  flex-direction: row;
  gap: 2em;
  padding: 2em;
  width: 50%;
  font-family: "Alpino-Black";
  font-size: 1.2em;
}
.container__footer_logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 1em;
  position: relative;
}
.container__footer_logo_title {
  font-family: "Alpino-Black";
  margin-right: 1em;
  color: white;
  z-index: 2;
}
.container__footer_logo > img {
  width: 35em;
  height: 15em;
  bottom: 0;
  /* border: 1px solid rgba(237, 220, 210, 0.5); */
  /* background-color: rgba(6, 6, 6, 0.2); */
  border-radius: 4px;
  -webkit-backdrop-filter: blur(6px);
  /* backdrop-filter: blur(6px); */
}
.container__footer_logo > span {
  font-size: 0.8em;
  color: #0abab5;
  font-weight: bold;
  z-index: 2;
}

.buy-now {
  padding: 0.5em;
  width: 10em;
  text-align: center;
  background-color: #0abab5;
  border-radius: 4px;
  color: black;
  bottom: 0;
  text-shadow: none !important;
  font-weight: bold;
  right: 0;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.top_banner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  z-index: 0;
}

.top_banner svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 50vh;
}

.top_banner .shape-fill {
  fill: #81d8d0;
}

.scene {
  width: 10em;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
}

.cube {
  color: #ccc;
  cursor: pointer;
  font-family: "Spartan", sans-serif;
  transition: all 0.85s cubic-bezier(0.17, 0.67, 0.14, 0.93);
  transform-style: preserve-3d;
  transform-origin: 100% 50%;
  width: 10em;
  height: 4em;
}

.cube:hover {
  transform: rotateX(-90deg);
}

.side {
  box-sizing: border-box;
  position: absolute;
  display: inline-block;
  height: 4em;
  width: 15em;
  text-align: center;
  text-transform: uppercase;
  padding-top: 1.5em;
  font-weight: bold;
}

.top {
  background: #eddcd2;
  color: #390879;
  transform: rotateX(90deg) translate3d(0, 0, 2em);
  box-shadow: inset 0 0 0 5px #fff;
}

.front {
  background-image: linear-gradient(to left, #390879, #3b176f, #3d2165, #3e295b, #3e3051);
  color: #eddcd2;
  box-shadow: inset 0 0 0 5px #fff;
  transform: translate3d(0, 0, 2em);
}

.video_animation {
  transition: all 2s ease-in-out;
  animation: fadeUP 1s ease-in-out forwards;
}

@keyframes fadeUP {
  0% {
    opacity: 0;
    filter: blur(50px);
    transform: translateY(80px) scale(1.2);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes fadeRH {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.events-overlay {
  position: absolute;
  width: 50%;
  height: 100%;
  z-index: 1;
  background-image: linear-gradient(to left top, #29335c, #29335c, #29335c, #29335c, #29335c, #473d64, #60496b, #765671, #9e7882, #bba09b, #d5c9c1, #f3f2ef);
  opacity: 0.8;
}

.events-overlay-2 {
  position: absolute;
  width: 50%;
  height: 100%;
  right: 0;
  z-index: 1;
  background-image: linear-gradient(to left top, #29335c, #29335c, #29335c, #29335c, #29335c, #473d64, #60496b, #765671, #9e7882, #bba09b, #d5c9c1, #f3f2ef);
  opacity: 0.8;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: rgba(10, 186, 181, 0.4);
}

.cardWrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
}

.cardWrap:hover .cardInfo {
  transform: translateY(0);
}

.cardWrap:hover .cardInfo p {
  opacity: 1;
}

.cardWrap:hover .cardInfo,
.cardWrap:hover .cardInfo p {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.cardWrap:hover .cardInfo:after {
  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 1;
  transform: translateY(0);
}

.cardWrap:hover .cardBg {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .cardBg1 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .cardBg2 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .card, .cardWrap:hover .galleryCard {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}

.card, .galleryCard {
  position: relative;
  flex: 0 0 240px;
  width: 350px;
  height: 200px;
  background-color: #333 !important;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset rgba(255, 255, 255, 0.5) 0 0 0 6px;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.galleryCard {
  width: 30em;
  height: 45em;
}

.cardTitle {
  font-size: 22px;
}

.cardInfo {
  padding: 20px;
  position: absolute;
  bottom: -25px;
  width: 100%;
  color: #fff;
  transform: translateY(40%);
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo p {
  font-size: 1rem;
  opacity: 0;
  font-family: "Spartan", sans-serif;
  text-shadow: black 0 2px 3px;
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo * {
  position: relative;
  z-index: 1;
  font-family: "Spartan", sans-serif;
}

.cardInfo:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
  background-blend-mode: overlay;
  opacity: 0;
  transform: translateY(100%);
  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.cardInfo h1 {
  font-family: "Spartan", sans-serif;
  font-size: 36px;
  font-weight: 700;
  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;
}

/*Just the background stuff*/
span.s1 {
  position: absolute;
  top: 0;
  font-size: 15rem;
  font-weight: 800;
  text-transform: uppercase;
  color: #3c4447;
}

span.s2 {
  font-weight: 800;
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 15rem;
  text-transform: uppercase;
  color: #3c4447;
}

/* The card */
.eventCard {
  position: relative;
  height: 450px;
  width: 900px;
  margin: 200px auto;
  z-index: 2;
  background-color: #fff;
  box-shadow: 10px 10px 93px 0px rgba(0, 0, 0, 0.75);
}

/* Image on the left side */
.thumbnail {
  float: left;
  position: relative;
  left: 30px;
  top: -30px;
  height: 320px;
  width: 530px;
  box-shadow: 10px 10px 60px 0px rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

/*object-fit: cover;*/
/*object-position: center;*/
img.left {
  position: absolute;
  left: 50%;
  top: 50%;
  height: auto;
  width: 100%;
  transform: translate(-50%, -50%);
}

/* Right side of the card */
.right {
  margin-left: 590px;
  margin-right: 20px;
}

h1 {
  padding-top: 15px;
  font-size: 1.3rem;
  color: #4b4b4b;
}

.author {
  background-color: #9ecaff;
  text-align: center;
  padding: 0.5em;
  border-radius: 20px;
}

h2 {
  padding-top: 8px;
  margin-right: 6px;
  text-align: right;
  font-size: 0.8rem;
}

.separator {
  margin-top: 10px;
  border: 1px solid #c3c3c3;
}

/* DATE of release*/
h5 {
  position: absolute;
  left: 30px;
  bottom: -120px;
  font-size: 6rem;
  color: #c3c3c3;
}

h6 {
  position: absolute;
  left: 30px;
  bottom: -55px;
  font-size: 2rem;
  color: #c3c3c3;
}

/* Those futur buttons */
ul {
  margin-left: 250px;
}

li {
  display: inline;
  list-style: none;
  padding-right: 40px;
  color: #7b7b7b;
}

/* Floating action button */
.fab {
  position: absolute;
  right: 50px;
  bottom: -40px;
  box-sizing: border-box;
  padding-top: 18px;
  background-color: #1875d0;
  width: 80px;
  height: 80px;
  color: white;
  text-align: center;
  border-radius: 50%;
  box-shadow: 10px 10px 50px 0px rgba(0, 0, 0, 0.75);
}

/*
* 
* ==========================================
*/
@media (min-width: 390px) {
  .container__service {
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 8em 0.5em;
  }
  .container__service_category {
    margin: 0;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    gap: 2em;
  }
  .container__service_category_container_img {
    width: 28em;
    height: 20em;
  }
  .container__about {
    padding: 0;
  }
  .container__about_title {
    width: 50%;
  }
  .container__about_section {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container__about_img-container {
    width: auto !important;
    height: 30em !important;
  }
  .container__about_img-container > img {
    object-fit: contain;
  }
  .container__about_p {
    width: 100%;
    font-size: 1.4em;
  }
  .container__gallery {
    flex-wrap: nowrap;
  }
  .container__gallery_title {
    width: 50%;
  }
  .container__gallery_top-grid {
    padding: 0;
  }
  .container__footer_logo > img {
    width: auto !important;
  }
  .container .galleryCard {
    width: 27em;
    height: 30em;
  }
  .eventCard {
    width: 500px;
    height: auto;
  }
  .eventCard > .thumbnail {
    width: 200px;
    height: 200px;
  }
  .eventCard > .thumbnail > img {
    height: 100%;
  }
  .eventCard > .right > h1 {
    text-align: end;
  }
  .eventCard > .right > .author > h2 {
    margin-left: 18em;
  }
  .eventCard > h5,
  h6 {
    display: none;
    opacity: 0;
  }
  .right {
    margin-left: 0;
  }
  .right > p {
    padding: 1em;
  }
}
@media (min-width: 768px) {
  .container__service_category_container {
    overflow: auto;
  }
  .container__service_category_container_img {
    width: 50em;
    height: 28em;
  }
  .container__about_section {
    flex-direction: column;
  }
  .container__about_img-container {
    width: 40em;
    height: 50em;
  }
}
@media (min-width: 1024px) {
  .container__about {
    padding: 0 !important;
  }
  .container__about_section {
    flex-direction: column !important;
    align-items: flex-start;
  }
  .container__about_img-container {
    position: absolute;
    top: 5%;
    right: 3%;
    z-index: 3;
  }
  .container__about_p {
    position: relative;
    width: 70% !important;
  }
  .container__service {
    z-index: 1;
    display: flex;
    flex-direction: column;
    padding: 10em 2em;
  }
  .container__service_category {
    gap: 2em;
    justify-content: center;
    margin: 2em 4em;
  }
  .container__service_category_container_img {
    width: 12em;
    height: 28em;
  }
  .container__footer_logo > img {
    width: 35em !important;
  }
  .eventCard {
    height: 450px;
    width: 900px;
  }
  .eventCard > .thumbnail {
    height: 320px;
    width: 530px;
  }
  .eventCard > .right {
    margin-left: 590px;
    margin-right: 20px;
  }
  .eventCard > .right > .author > h2 {
    margin-left: 0;
  }
  .right {
    margin-left: 590px;
  }
  .eventCard > h5,
  h6 {
    display: block;
    opacity: 1;
  }
  .container__service_category {
    margin: 20px 0;
    justify-content: center;
  }
  .container__service_category_container_img {
    width: 12em;
    height: 28em;
  }
  .container__about {
    padding: 10em;
  }
  .container__about_section {
    flex-direction: row;
  }
  .container__about_p {
    width: 70%;
  }
  .galleryCard {
    width: 18em !important;
    height: 25em !important;
  }
}
@media (min-width: 1280px) {
  .container__about_section {
    align-items: center;
  }
  .container__about_img-container {
    position: absolute;
    top: 5%;
    right: 2%;
    z-index: 3;
  }
  .container__about_p {
    width: 60% !important;
  }
  .container__service {
    padding: 10em 15em;
  }
  .galleryCard {
    width: 28em !important;
    height: 35em !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Main/Main.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;;EAEE,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBCHY;EDIZ,8BAAA;EACA,mCAAA;AAAF;AAEE;EACE,0JAAA;EAeA,kBAAA;EACA,cCzBU;ED0BV,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAdJ;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,cC/CY;EDgDZ,0CAAA;EACA,8CAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AAfN;AAgBM;EACE,cC3DQ;AD6ChB;AAkBI;EACE,aAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,UAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBCrEQ;EDsER,cCxEW;EDyEX,8CAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,cClFQ;EDmFR,iBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;AAjBR;AAsBM;EACE,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,8CAAA;EACA,iBAAA;AApBR;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,qFAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAvBJ;AAyBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,yBCjHM;AD0FZ;AA0BI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,cChIY;EDiIZ,0CAAA;EACA,4CAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AAxBN;AA2BI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;AAzBN;AA2BM;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;AA1BR;AA2BQ;EACE,eAAA;AAzBV;AA+BE;EACE,qFAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA7BJ;AA+BI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AA7BN;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AA9BN;AAgCM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA9BR;AA+BQ;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,gCAAA;EAGA,eAAA;AA/BV;AAgCU;EACE,UAAA;EACA,2BAAA;EACA,YAAA;EAGA,6FAAA;EAEA,kJAAA;AAhCZ;AAuCM;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AArCR;AAyCI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAvCN;AAyCM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAvCR;AAyCQ;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EAEA,gCAAA;EAEA,eAAA;AAzCV;AA0CU;EACE,YAAA;EACA,UAAA;EACA,2BAAA;EAGA,6FAAA;EAEA,kJAAA;AA1CZ;AAiDM;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA/CR;AAmDI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAjDN;AAmDM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAjDR;AAmDQ;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,gCAAA;EAGA,eAAA;AAnDV;AAoDU;EACE,YAAA;EACA,UAAA;EACA,2BAAA;EAIA,6FAAA;EAEA,kJAAA;AArDZ;AA4DM;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA1DR;AA+DE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AA7DJ;AA+DI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AA7DN;AAgEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,cCnXY;EDoXZ,0CAAA;EACA,8CAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AA9DN;AAiEI;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;AA/DN;AAiEM;EACE,WAAA;AA/DR;AAuEE;EAiBE,aAAA;EACA,sBAAA;EACA,kBAAA;AArFJ;AAsFI;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;AApFN;AAuFM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AArFR;AAwFM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAtFR;AA0FI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,cCjcM;EDkcN,0CAAA;EACA,8CAAA;EACA,kBAAA;EACA,OAAA;EACA,kCAAA;UAAA,0BAAA;EACA,WAAA;AAxFN;AA4FE;EACE,0CAAA;EACA,yBC3cU;ED4cV,kBAAA;EACA,kCAAA;UAAA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA1FJ;AA4FI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,gBAAA;AA1FN;AA6FI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA3FN;AAkGM;EACE,2BAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;AAhGR;AAkGM;EACE,WAAA;EACA,YAAA;EAEA,SAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;EACA,gCAAA;AAjGR;AAoGM;EACE,gBAAA;EACA,cCzgBQ;ED0gBR,iBAAA;EACA,UAAA;AAlGR;;AAwGA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,4BAAA;EACA,iBAAA;EACA,QAAA;AArGF;;AAwGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArGF;;AAwGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AArGF;;AAwGA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AArGF;;AAwGA;EACE,aAAA;AArGF;;AAwGA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AArGF;;AAwGA;EACE,WAAA;EACA,eAAA;EACA,kCAAA;EACA,0DAAA;EACA,4BAAA;EACA,0BAAA;EACA,WAAA;EACA,WAAA;AArGF;;AAwGA;EACE,0BAAA;AArGF;;AAwGA;EACE,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AArGF;;AAwGA;EACE,mBCtlBU;EDulBV,cAAA;EACA,gDAAA;EACA,gCAAA;AArGF;;AAwGA;EACE,uFAAA;EAQA,cCrmBU;EDsmBV,gCAAA;EACA,iCAAA;AA5GF;;AA+GA;EACE,8BAAA;EACA,yCAAA;AA5GF;;AA+GA;EACE;IACE,UAAA;IACA,kBAAA;IACA,sCAAA;EA5GF;EA8GA;IACE,UAAA;IACA,iCAAA;EA5GF;AACF;AA+GA;EACE;IACE,UAAA;IACA,4BAAA;EA7GF;EA+GA;IACE,UAAA;IACA,wBAAA;EA7GF;AACF;AAgHA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,0JAAA;EAeA,YAAA;AA5HF;;AAgIA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,0JAAA;EAeA,YAAA;AA3IF;;AA+IA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yCAAA;AA5IF;;AA+IA;EACE,YAAA;EAEA,6BAAA;EAEA,4BAAA;EACA,eAAA;AA5IF;;AA+IA;EAEE,wBAAA;AA5IF;;AA+IA;EACE,UAAA;AA5IF;;AA+IA;;EAGE,+CAAA;AA5IF;;AA+IA;EAEE,6CAAA;EACA,UAAA;EAEA,wBAAA;AA5IF;;AA+IA;EAGE,0FAAA;EAEA,YAAA;AA9IF;;AAiJA;EAGE,0FAAA;EAEA,YAAA;AAhJF;;AAmJA;EAGE,0FAAA;EAEA,YAAA;AAlJF;;AAqJA;EAGE,6FAAA;EAEA,kJAAA;AApJF;;AAyJA;EACE,kBAAA;EAEA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,6GAAA;EAGA,oDAAA;AAvJF;;AA0JA;EAEE,WAAA;EACA,YAAA;AAxJF;;AA2JA;EACE,eAAA;AAxJF;;AA2JA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;EAEA,yDAAA;AAxJF;;AA2JA;EACE,eAAA;EACA,UAAA;EACA,kCAAA;EACA,4BAAA;EAEA,yDAAA;AAxJF;;AA2JA;EACE,kBAAA;EACA,UAAA;EACA,kCAAA;AAxJF;;AA2JA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAQA,qFAAA;EAKA,8BAAA;EACA,UAAA;EAEA,2BAAA;EAEA,uDAAA;AAlKF;;AAqKA;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AAlKF;;AAsKA,4BAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAnKF;;AAsKA;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AAnKF;;AAsKA,aAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EAGA,kDAAA;AAnKF;;AAsKA,2BAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EAGA,kDAAA;EACA,gBAAA;AAnKF;;AAsKA,qBAAA;AACA,2BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EAGA,gCAAA;AAnKF;;AAsKA,2BAAA;AACA;EACE,kBAAA;EACA,kBAAA;AAnKF;;AAsKA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AAnKF;;AAsKA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAnKF;;AAsKA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAnKF;;AAqKA;EACE,gBAAA;EACA,yBAAA;AAlKF;;AAuKA,mBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AApKF;;AAuKA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AApKF;;AAuKA,wBAAA;AACA;EACE,kBAAA;AApKF;;AAuKA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AApKF;;AAuKA,2BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,kDAAA;AApKF;;AAuKA;;;CAAA;AEl+BE;EFy+BE;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,kBAAA;EAtKJ;EAuKI;IACE,SAAA;IACA,uBAAA;IACA,eAAA;IACA,WAAA;IACA,QAAA;EArKN;EAwKQ;IACE,WAAA;IACA,YAAA;EAtKV;EA2KE;IACE,UAAA;EAzKJ;EA2KI;IACE,UAAA;EAzKN;EA4KI;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;EA1KN;EA6KI;IACE,sBAAA;IACA,uBAAA;EA3KN;EA6KM;IACE,mBAAA;EA3KR;EA+KI;IACE,WAAA;IACA,gBAAA;EA7KN;EAiLE;IACE,iBAAA;EA/KJ;EAiLI;IACE,UAAA;EA/KN;EAkLI;IACE,UAAA;EAhLN;EAqLI;IACE,sBAAA;EAnLN;EAuLE;IACA,WAAA;IACA,YAAA;EArLF;EAyLA;IACE,YAAA;IACA,YAAA;EAvLF;EA0LE;IACE,YAAA;IACA,aAAA;EAxLJ;EA0LI;IACE,YAAA;EAxLN;EA6LI;IACE,eAAA;EA3LN;EA+LM;IACE,iBAAA;EA7LR;EAoMA;;IAEE,aAAA;IACA,UAAA;EAlMF;EAqMA;IACE,cAAA;EAnMF;EAsMA;IACE,YAAA;EApMF;AACF;AEh5BE;EFylCE;IACE,cAAA;EAtMJ;EAyME;IACE,WAAA;IACA,YAAA;EAvMJ;EA0MI;IACE,sBAAA;EAxMN;EA2MI;IACE,WAAA;IACA,YAAA;EAzMN;AACF;AE15BE;EF8mCE;IACE,qBAAA;EAjNJ;EAmNI;IACE,iCAAA;IACA,uBAAA;EAjNN;EAoNI;IACE,kBAAA;IACA,OAAA;IACA,SAAA;IACA,UAAA;EAlNN;EAqNI;IACE,kBAAA;IACA,qBAAA;EAnNN;EAsNE;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,iBAAA;EApNJ;EAsNI;IACE,QAAA;IACA,uBAAA;IACA,eAAA;EApNN;EAuNQ;IACE,WAAA;IACA,YAAA;EArNV;EA4NI;IACE,sBAAA;EA1NN;EA+NA;IACE,aAAA;IACA,YAAA;EA7NF;EA+NE;IACE,aAAA;IACA,YAAA;EA7NJ;EAgOE;IACE,kBAAA;IACA,kBAAA;EA9NJ;EAiOM;IACE,cAAA;EA/NR;EAqOA;IACE,kBAAA;EAnOF;EAsOA;;IAEE,cAAA;IACA,UAAA;EApOF;EAwOI;IACE,cAAA;IACA,uBAAA;EAtON;EA0OE;IACE,WAAA;IACA,YAAA;EAxOJ;EA2OE;IACE,aAAA;EAzOJ;EA2OI;IACE,mBAAA;EAzON;EAiPI;IACE,UAAA;EA/ON;EAoPA;IACE,sBAAA;IACA,uBAAA;EAlPF;AACF;AEr+BE;EF6tCI;IACE,mBAAA;EArPN;EAuPI;IACE,kBAAA;IACA,OAAA;IACA,SAAA;IACA,UAAA;EArPN;EAwPI;IACE,qBAAA;EAtPN;EAyPE;IACE,kBAAA;EAvPJ;EA2PA;IACE,sBAAA;IACA,uBAAA;EAzPF;AACF","sourcesContent":["@import \"../../assets/scss/components/imports.scss\";\n\n*,\nhtml {\n  scroll-behavior: smooth;\n}\n\n.container {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  background-color: $black-color;\n  transition: all 2s ease-in-out;\n  -webkit-font-smoothing: antialiased;\n\n  &__about {\n    background-image: linear-gradient(\n      to left top,\n      #29335c,\n      #29335c,\n      #29335c,\n      #29335c,\n      #29335c,\n      #473d64,\n      #60496b,\n      #765671,\n      #9e7882,\n      #bba09b,\n      #d5c9c1,\n      #f3f2ef\n    );\n    position: relative;\n    color: $white-color;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    z-index: 2;\n    text-align: center;\n    z-index: 1;\n    // padding: 10em;\n\n    &_title {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 0em 2em;\n      width: 30%;\n      border-radius: 4px;\n      z-index: 2;\n      font-family: \"Alpino-Black\";\n      color: $dark-pink-color;\n      background-color: rgba(255, 255, 255, 0.7);\n      box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 4px;\n      left: 0;\n      backdrop-filter: blur(6px);\n      height: 2em;\n      & > span {\n        color: $tiffany-color;\n      }\n    }\n\n    &_section {\n      display: flex;\n      flex-direction: row;\n    }\n\n    &_p {\n      width: 70%;\n      z-index: 2;\n      padding: 1.5em;\n      line-height: 2em;\n      font-size: 1.5em;\n      font-family: \"Alpino-Black\";\n      font-weight: bold;\n      background-color: $white-color;\n      color: $dark-tan-color;\n      box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 10px;\n\n      &_i {\n        color: $tiffany-color;\n        font-weight: bold;\n        font-family: \"Alpino-Black\";\n        padding: 1em;\n        font-size: 1.2em;\n      }\n    }\n\n    &_img-container {\n      & > img {\n        border-radius: 10px;\n        border: 1px solid rgba(255, 255, 255, 0.2);\n        transform: translateY(-1px);\n        box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.5);\n        object-fit: cover;\n      }\n    }\n  }\n\n  &__feature {\n    display: flex;\n    flex-direction: column;\n    background-image: url(\"https://awt-site.s3.us-east-2.amazonaws.com/white-couch.jpeg\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    height: 80vh;\n    position: relative;\n    z-index: 2;\n\n    &_overlay {\n      position: absolute;\n      width: 100%;\n      height: 80vh;\n      z-index: 1;\n      opacity: 0;\n      background-color: $tan-color;\n    }\n\n    &_title {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 0em 2em;\n      width: 30%;\n      border-radius: 4px;\n      z-index: 2;\n      font-family: \"Alpino-Black\";\n      color: $dark-pink-color;\n      background-color: rgba(255, 255, 255, 0.8);\n      box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 4px;\n      left: 0;\n      backdrop-filter: blur(6px);\n      height: 2em;\n    }\n\n    &_content {\n      z-index: 2;\n      display: flex;\n      flex-direction: row;\n      gap: 8em;\n      justify-content: center;\n      padding: 2em;\n\n      &_img {\n        // filter: blur(10px);\n        width: 28em;\n        height: 30em;\n        border-radius: 8px;\n        overflow: hidden;\n        transition: all 1s ease-in-out;\n        border: 2px solid $pink-color;\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  &__gallery {\n    background-image: url(\"https://awt-site.s3.us-east-2.amazonaws.com/white-couch.jpeg\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    overflow: hidden;\n    position: relative;\n\n    &_title {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 0em 2em;\n      width: 30%;\n      border-radius: 4px;\n      z-index: 2;\n      font-family: \"Alpino-Black\";\n      color: #390879;\n      background-color: white;\n      box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 4px;\n      left: 0;\n      backdrop-filter: blur(6px);\n      height: 2em;\n    }\n\n    &_top-grid {\n      display: flex;\n      flex-direction: row;\n      align-self: center;\n      justify-content: center;\n      flex-wrap: wrap;\n      gap: 2em;\n      padding: 4em;\n      z-index: 2;\n\n      &_container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        & > img {\n          height: 40em;\n          box-sizing: inherit;\n          -webkit-font-smoothing: antialiased;\n          background-color: white;\n          transition: all 0.3s ease-in-out;\n          // padding: 1em;\n          // margin: 20px;\n          cursor: pointer;\n          &:hover {\n            z-index: 1;\n            transform: translateY(-1px);\n            height: 50em;\n            -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n              rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n              inset white 0 0 0 6px;\n          }\n        }\n      }\n\n      &_buy-btn {\n        padding: 1em;\n        width: 5em;\n        text-align: center;\n        background-color: #0abab5;\n        color: black;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n      }\n    }\n\n    &_middle-grid {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      align-self: center;\n      gap: 3em;\n      padding: 3em;\n      z-index: 2;\n\n      &_container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n\n        & > img {\n          height: 40em;\n          box-sizing: inherit;\n          -webkit-font-smoothing: antialiased;\n          background-color: white;\n          // padding: 1em;\n          transition: all 0.3s ease-in-out;\n\n          cursor: pointer;\n          &:hover {\n            height: 50em;\n            z-index: 1;\n            transform: translateY(-1px);\n            -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n              rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n              inset white 0 0 0 6px;\n          }\n        }\n      }\n\n      &_buy-btn {\n        padding: 1em;\n        width: 5em;\n        text-align: center;\n        background-color: #0abab5;\n        color: black;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n      }\n    }\n\n    &_bottom-grid {\n      display: flex;\n      flex-direction: row;\n      align-self: center;\n      gap: 3em;\n      padding: 3em;\n\n      &_container {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n\n        & > img {\n          height: 40em;\n          box-sizing: inherit;\n          -webkit-font-smoothing: antialiased;\n          background-color: white;\n          transition: all 0.3s ease-in-out;\n\n          // margin: 20px;\n          cursor: pointer;\n          &:hover {\n            height: 50em;\n            z-index: 1;\n            transform: translateY(-1px);\n\n            -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n              box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n            box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n              rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n              inset white 0 0 0 6px;\n          }\n        }\n      }\n\n      &_buy-btn {\n        padding: 1em;\n        width: 5em;\n        text-align: center;\n        background-color: #0abab5;\n        color: black;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n      }\n    }\n  }\n\n  &__events {\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n    position: relative;\n\n    &_section {\n      display: flex;\n      flex-direction: row;\n      gap: 1em;\n      justify-content: center;\n      align-items: center;\n    }\n\n    &_title {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 0em 2em;\n      width: 30%;\n      border-radius: 4px;\n      z-index: 2;\n      font-family: \"Alpino-Black\";\n      color: $dark-pink-color;\n      background-color: rgba(255, 255, 255, 0.7);\n      box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 4px;\n      left: 0;\n      backdrop-filter: blur(6px);\n      height: 2em;\n    }\n\n    &_img-container {\n      width: 5em;\n      height: 30em;\n      border-radius: calc(5em / 2);\n      border: 1px solid $tiffany-2-color;\n      overflow: hidden;\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n      position: relative;\n\n      &:active {\n        width: 45em;\n      }\n\n      &_content {\n      }\n    }\n  }\n\n  &__book {\n    // background-image: linear-gradient(to right, #390879, #42004e, #37002d, #230316, #000000);\n    // background-image: linear-gradient(\n    //   to right bottom,\n    //   #29335c,\n    //   #29335c,\n    //   #29335c,\n    //   #29335c,\n    //   #29335c,\n    //   #473d64,\n    //   #60496b,\n    //   #765671,\n    //   #9e7882,\n    //   #bba09b,\n    //   #d5c9c1,\n    //   #f3f2ef\n    // );\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    &_container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-evenly;\n      gap: 1em;\n      padding: 10em;\n      z-index: 2;\n      // flex-wrap: wrap;\n\n      &_lf {\n        width: 100%;\n        height: 50vh;\n        background-color: white;\n      }\n\n      &_rh {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n      }\n    }\n\n    &_title {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start;\n      padding: 0em 2em;\n      width: 30%;\n      border-radius: 4px;\n      z-index: 2;\n      font-family: \"Alpino-Black\";\n      color: $tan-color;\n      background-color: rgba(255, 255, 255, 0.7);\n      box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n      border-radius: 4px;\n      left: 0;\n      backdrop-filter: blur(6px);\n      height: 2em;\n    }\n  }\n\n  &__footer {\n    border: 1px solid rgba(237, 220, 210, 0.5);\n    background-color: $black-color;\n    border-radius: 4px;\n    backdrop-filter: blur(6px);\n    height: 40vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 3em;\n    // gap: 10em;\n    &_links {\n      display: flex;\n      flex-direction: row;\n      gap: 2em;\n      padding: 2em;\n      width: 50%;\n      font-family: \"Alpino-Black\";\n      font-size: 1.2em;\n    }\n\n    &_logo {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      margin: auto;\n      padding: 1em;\n      position: relative;\n\n      // border: 1px solid rgba(237, 220, 210, 0.5);\n      // background-color: rgba(6, 6, 6, 0.2);\n      // border-radius: 4px;\n      // backdrop-filter: blur(6px);\n\n      &_title {\n        font-family: \"Alpino-Black\";\n        margin-right: 1em;\n        color: white;\n        z-index: 2;\n      }\n      & > img {\n        width: 35em;\n        height: 15em;\n        // position: absolute;\n        bottom: 0;\n        /* border: 1px solid rgba(237, 220, 210, 0.5); */\n        /* background-color: rgba(6, 6, 6, 0.2); */\n        border-radius: 4px;\n        -webkit-backdrop-filter: blur(6px);\n        /* backdrop-filter: blur(6px); */\n      }\n\n      & > span {\n        font-size: 0.8em;\n        color: $tiffany-color;\n        font-weight: bold;\n        z-index: 2;\n      }\n    }\n  }\n}\n\n.buy-now {\n  padding: .5em;\n  width: 10em;\n  text-align: center;\n  background-color: #0abab5;\n  border-radius: 4px;\n  color: black;\n  bottom: 0;\n  text-shadow: none !important;\n  font-weight: bold;\n  right: 0;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.top_banner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n  z-index: 0;\n}\n\n.top_banner svg {\n  position: relative;\n  display: block;\n  width: calc(100% + 1.3px);\n  height: 50vh;\n}\n\n.top_banner .shape-fill {\n  fill: #81d8d0;\n}\n\n.scene {\n  width: 10em;\n  justify-content: center;\n  align-items: center;\n  margin-top: -20px;\n}\n\n.cube {\n  color: #ccc;\n  cursor: pointer;\n  font-family: \"Spartan\", sans-serif;\n  transition: all 0.85s cubic-bezier(0.17, 0.67, 0.14, 0.93);\n  transform-style: preserve-3d;\n  transform-origin: 100% 50%;\n  width: 10em;\n  height: 4em;\n}\n\n.cube:hover {\n  transform: rotateX(-90deg);\n}\n\n.side {\n  box-sizing: border-box;\n  position: absolute;\n  display: inline-block;\n  height: 4em;\n  width: 15em;\n  text-align: center;\n  text-transform: uppercase;\n  padding-top: 1.5em;\n  font-weight: bold;\n}\n\n.top {\n  background: $tan-color;\n  color: #390879;\n  transform: rotateX(90deg) translate3d(0, 0, 2em);\n  box-shadow: inset 0 0 0 5px #fff;\n}\n\n.front {\n  background-image: linear-gradient(\n    to left,\n    #390879,\n    #3b176f,\n    #3d2165,\n    #3e295b,\n    #3e3051\n  );\n  color: $tan-color;\n  box-shadow: inset 0 0 0 5px #fff;\n  transform: translate3d(0, 0, 2em);\n}\n\n.video_animation {\n  transition: all 2s ease-in-out;\n  animation: fadeUP 1s ease-in-out forwards;\n}\n\n@keyframes fadeUP {\n  0% {\n    opacity: 0;\n    filter: blur(50px);\n    transform: translateY(80px) scale(1.2);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes fadeRH {\n  0% {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.events-overlay {\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  z-index: 1;\n  background-image: linear-gradient(\n    to left top,\n    #29335c,\n    #29335c,\n    #29335c,\n    #29335c,\n    #29335c,\n    #473d64,\n    #60496b,\n    #765671,\n    #9e7882,\n    #bba09b,\n    #d5c9c1,\n    #f3f2ef\n  );\n  opacity: 0.8;\n  // background-color: rgba(10, 186, 181, 0.8);\n}\n\n.events-overlay-2 {\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  right: 0;\n  z-index: 1;\n  background-image: linear-gradient(\n    to left top,\n    #29335c,\n    #29335c,\n    #29335c,\n    #29335c,\n    #29335c,\n    #473d64,\n    #60496b,\n    #765671,\n    #9e7882,\n    #bba09b,\n    #d5c9c1,\n    #f3f2ef\n  );\n  opacity: 0.8;\n  // background-color: rgba(10, 186, 181, 0.8);\n}\n\n.overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  background-color: rgba(10, 186, 181, 0.4);\n}\n\n.cardWrap {\n  margin: 10px;\n  -webkit-transform: perspective(800px);\n  transform: perspective(800px);\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  cursor: pointer;\n}\n\n.cardWrap:hover .cardInfo {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n.cardWrap:hover .cardInfo p {\n  opacity: 1;\n}\n\n.cardWrap:hover .cardInfo,\n.cardWrap:hover .cardInfo p {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.cardWrap:hover .cardInfo:after {\n  -webkit-transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 1;\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n.cardWrap:hover .cardBg {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .cardBg1 {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .cardBg2 {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .card {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n    rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n    inset white 0 0 0 6px;\n}\n\n.card {\n  position: relative;\n  -webkit-box-flex: 0;\n  flex: 0 0 240px;\n  width: 350px;\n  height: 200px;\n  background-color: #333 !important;\n  overflow: hidden;\n  border-radius: 4px;\n  box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n    inset rgba(255, 255, 255, 0.5) 0 0 0 6px;\n  -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n\n.galleryCard {\n  @extend .card;\n  width: 30em;\n  height: 45em;\n}\n\n.cardTitle {\n  font-size: 22px;\n}\n\n.cardInfo {\n  padding: 20px;\n  position: absolute;\n  bottom: -25px;\n  width: 100%;\n  color: #fff;\n  -webkit-transform: translateY(40%);\n  transform: translateY(40%);\n  -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.cardInfo p {\n  font-size: 1rem;\n  opacity: 0;\n  font-family: \"Spartan\", sans-serif;\n  text-shadow: black 0 2px 3px;\n  -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.cardInfo * {\n  position: relative;\n  z-index: 1;\n  font-family: \"Spartan\", sans-serif;\n}\n\n.cardInfo:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(transparent),\n    to(rgba(0, 0, 0, 0.8))\n  );\n  background-image: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.8) 100%\n  );\n  background-blend-mode: overlay;\n  opacity: 0;\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  -webkit-transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n\n.cardInfo h1 {\n  font-family: \"Spartan\", sans-serif;\n  font-size: 36px;\n  font-weight: 700;\n  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;\n}\n\n@import url(https://fonts.googleapis.com/css?family=Roboto);\n/*Just the background stuff*/\nspan.s1 {\n  position: absolute;\n  top: 0;\n  font-size: 15rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #3c4447;\n}\n\nspan.s2 {\n  font-weight: 800;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  font-size: 15rem;\n  text-transform: uppercase;\n  color: #3c4447;\n}\n\n/* The card */\n.eventCard {\n  position: relative;\n  height: 450px;\n  width: 900px;\n  margin: 200px auto;\n  z-index: 2;\n  background-color: #fff;\n  -webkit-box-shadow: 10px 10px 93px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 10px 10px 93px 0px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 10px 93px 0px rgba(0, 0, 0, 0.75);\n}\n\n/* Image on the left side */\n.thumbnail {\n  float: left;\n  position: relative;\n  left: 30px;\n  top: -30px;\n  height: 320px;\n  width: 530px;\n  -webkit-box-shadow: 10px 10px 60px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 10px 10px 60px 0px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 10px 60px 0px rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n}\n\n/*object-fit: cover;*/\n/*object-position: center;*/\nimg.left {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: auto;\n  width: 100%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n/* Right side of the card */\n.right {\n  margin-left: 590px;\n  margin-right: 20px;\n}\n\nh1 {\n  padding-top: 15px;\n  font-size: 1.3rem;\n  color: #4b4b4b;\n}\n\n.author {\n  background-color: #9ecaff;\n  text-align: center;\n  padding: 0.5em;\n  border-radius: 20px;\n}\n\nh2 {\n  padding-top: 8px;\n  margin-right: 6px;\n  text-align: right;\n  font-size: 0.8rem;\n}\n.separator {\n  margin-top: 10px;\n  border: 1px solid #c3c3c3;\n}\n\n\n\n/* DATE of release*/\nh5 {\n  position: absolute;\n  left: 30px;\n  bottom: -120px;\n  font-size: 6rem;\n  color: #c3c3c3;\n}\n\nh6 {\n  position: absolute;\n  left: 30px;\n  bottom: -55px;\n  font-size: 2rem;\n  color: #c3c3c3;\n}\n\n/* Those futur buttons */\nul {\n  margin-left: 250px;\n}\n\nli {\n  display: inline;\n  list-style: none;\n  padding-right: 40px;\n  color: #7b7b7b;\n}\n\n/* Floating action button */\n.fab {\n  position: absolute;\n  right: 50px;\n  bottom: -40px;\n  box-sizing: border-box;\n  padding-top: 18px;\n  background-color: #1875d0;\n  width: 80px;\n  height: 80px;\n  color: white;\n  text-align: center;\n  border-radius: 50%;\n  -webkit-box-shadow: 10px 10px 50px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 10px 10px 50px 0px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 10px 50px 0px rgba(0, 0, 0, 0.75);\n}\n\n/*\n* \n* ==========================================\n*/\n\n@include screen-sm {\n  .container {\n    &__service {\n      z-index: 1;\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      padding: 8em 0.5em;\n      &_category {\n        margin: 0;\n        justify-content: center;\n        flex-wrap: wrap;\n        width: 100%;\n        gap: 2em;\n\n        &_container {\n          &_img {\n            width: 28em;\n            height: 20em;\n          }\n        }\n      }\n    }\n    &__about {\n      padding: 0;\n\n      &_title {\n        width: 50%;\n      }\n\n      &_section {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n\n      &_img-container {\n        width: auto !important;\n        height: 30em !important;\n\n        & > img {\n          object-fit: contain;\n        }\n      }\n\n      &_p {\n        width: 100%;\n        font-size: 1.4em;\n      }\n    }\n\n    &__gallery {\n      flex-wrap: nowrap;\n\n      &_title {\n        width: 50%;\n      }\n\n      &_top-grid {\n        padding: 0;\n      }\n    }\n\n    &__footer_logo {\n      & > img {\n        width: auto !important;\n      }\n    }\n\n    .galleryCard {\n    width: 27em;\n    height: 30em;\n    }\n  }\n\n  .eventCard {\n    width: 500px;\n    height: auto;\n    // height: 450px;\n    // width: 900px;\n    & > .thumbnail {\n      width: 200px;\n      height: 200px;\n\n      & > img {\n        height: 100%;\n      }\n    }\n\n    & > .right {\n      & > h1 {\n        text-align: end;\n      }\n\n      & > .author {\n        & > h2 {\n          margin-left: 18em;\n        }\n      }\n    }\n\n  }\n\n  .eventCard > h5,\n  h6 {\n    display: none;\n    opacity: 0;\n  }\n\n  .right {\n    margin-left: 0;\n  }\n\n  .right > p {\n    padding: 1em;\n  }\n}\n\n@include screen-md {\n  .container {\n    &__service_category_container {\n      overflow: auto;\n    }\n\n    &__service_category_container_img {\n      width: 50em;\n      height: 28em;\n    }\n    &__about {\n      &_section {\n        flex-direction: column;\n      }\n\n      &_img-container {\n        width: 40em;\n        height: 50em;\n      }\n\n      // &_p {\n      //   width: auto;\n      // }\n    }\n  }\n}\n\n@include screen-lg {\n  .container {\n    &__about {\n      padding: 0 !important;\n\n      &_section {\n        flex-direction: column !important;\n        align-items: flex-start;\n      }\n\n      &_img-container {\n        position: absolute;\n        top: 5%;\n        right: 3%;\n        z-index: 3;\n      }\n\n      &_p {\n        position: relative;\n        width: 70% !important;\n      }\n    }\n    &__service {\n      z-index: 1;\n      display: flex;\n      flex-direction: column;\n      padding: 10em 2em;\n\n      &_category {\n        gap: 2em;\n        justify-content: center;\n        margin: 2em 4em;\n\n        &_container {\n          &_img {\n            width: 12em;\n            height: 28em;\n          }\n        }\n      }\n    }\n\n    &__footer_logo {\n      & > img {\n        width: 35em !important;\n      }\n    }\n  }\n\n  .eventCard {\n    height: 450px;\n    width: 900px;\n\n    & > .thumbnail {\n      height: 320px;\n      width: 530px;\n    }\n\n    & > .right {\n      margin-left: 590px;\n      margin-right: 20px;\n\n      & > .author {\n        & > h2 {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n\n  .right {\n    margin-left: 590px;\n  }\n\n  .eventCard > h5,\n  h6 {\n    display: block;\n    opacity: 1;\n  }\n  .container {\n    &__service {\n      &_category {\n        margin: 20px 0;\n        justify-content: center;\n      }\n    }\n\n    &__service_category_container_img {\n      width: 12em;\n      height: 28em;\n    }\n\n    &__about {\n      padding: 10em;\n\n      &_section {\n        flex-direction: row;\n      }\n\n      // &_img-container {\n      //   width: 12em;\n      //   height: 28em;\n      // }\n\n      &_p {\n        width: 70%;\n      }\n    }\n  }\n\n  .galleryCard {\n    width: 18em !important;\n    height: 25em !important;\n  }\n}\n\n@include screen-xl {\n  .container {\n    &__about {\n      &_section {\n        align-items: center;\n      }\n      &_img-container {\n        position: absolute;\n        top: 5%;\n        right: 2%;\n        z-index: 3;\n      }\n\n      &_p {\n        width: 60% !important;\n      }\n    }\n    &__service {\n      padding: 10em 15em;\n    }\n  }\n\n  .galleryCard {\n    width: 28em !important;\n    height: 35em !important;\n  }\n}\n\n@include screen-2xl {\n}\n","$tiffany-color: #0abab5;\n$dark-tiffany-color: #113935;\n$tiffany-2-color: #9ae0d9;\n$pink-color: #ffbcd7;\n$dark-pink-color: #ff7db1;\n$dark-tan-color: #c99578;\n$tan-color: #eddcd2;\n$white-color: #f3f2ef;\n$black-color: #232223;\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
